export const CARD_TYPE = {
  SIM: 'sim',
  RSIM: 'rsim',
} as const;
